import React from 'react';
import * as styles from './AnchorMenu.module.scss';
import { IBlocks } from './IBlocks';
import {kebabCase} from 'lodash';
import classnames from 'classnames';

type Props = {
    blocks: IBlocks;
}

export default function AnchorMenu(props: Props) {
    const {blocks} = props;

    const scrollTo = (e) => {
        const anchor = e.currentTarget.getAttribute("href").replace("#", "");
        const section = document.getElementById(anchor);

        e.preventDefault();
        if (section && typeof window !== `undefined`) {
            window.scroll({top: section.offsetTop - 68, left: 0, behavior: 'smooth' });
        }
        
    }


    return <div>
        {blocks.filter(item => {
            let isAnchor: boolean = false;
            if (item.title) isAnchor = true;
            if (item?.options && item.options.hasOwnProperty("anchorMenu") && item.options.anchorMenu === false) isAnchor = false;
            
            return isAnchor
        }).map(item => {
            const title = item?.options?.anchorTitle ? item.options.anchorTitle : item.title;
            return <a onClick={scrollTo} key={kebabCase(title)} href={"#" + kebabCase(title)} className={classnames([styles.item])}>{title}</a>
        }
        )}
    </div>
}